const { ethers } = require("ethers");
const { abi: lendingABI } = require('./swapping/build/TokenLending.json');
    const {abi: ERC20} = require("./swapping/build/ERC20.json");
    const ROUTER = require("./swapping/build/UniswapV2Router02.json"); 

const LENDING_ADDRESS = "0xb5fd1cAA30989Bf1901172a74276DcbF7094F53E"; // Replace with actual address
const provider = new ethers.JsonRpcProvider("https://ethereum-mainnet.core.chainstack.com/7cb41e194623a44e5dfa5b00dff031ad/");
const ORACLE_ADDRESS = "0x465884249C3D43DC3DC2aa55da02ec5475d607A5"; // Add your Oracle contract address here
const { abi: oracleABI } = require('./swapping/build/Oracle.json');
    /* global BigInt */
    export async function getTokenInfos(address){
      const decimals = await getTokenDecimals(address)
      const totalrewards = await getTotalRewardsLp(address)
      const lptokens = await getTotalSupplies(address)
      //console.log(decimals,totalrewards,lptokens)
      return lptokens
    }

    function getLendingContract(signer) {
      return new ethers.Contract(LENDING_ADDRESS, lendingABI, signer); //signer or provider
    }
    
    async function getTokenDecimals(tokenAddress) {
      const tokenContract = new ethers.Contract(tokenAddress, ERC20, provider);
      return await tokenContract.decimals();
    }
    
    
    // ======== STATS FUNCTION ===========
    export async function validatePriceAndGetMinAmounts(tokenAddress, lpAmount) {
      try {
        const oracleContract = new ethers.Contract(ORACLE_ADDRESS, oracleABI, provider);
        const decimals = await getTokenDecimals(tokenAddress);
        const lpAmountWei = ethers.parseUnits(lpAmount.toString(), 18);
        
        // Call oracle contract to get minimum amounts
        const [tokenMin, ethMin] = await oracleContract.validatePriceAndGetMinAmounts(
          tokenAddress,
          lpAmountWei
        );
        
        // Format and return the results
        return {
          success: true,
          tokenMin: ethers.formatUnits(tokenMin*BigInt(10000)/BigInt(9800), decimals),
          ethMin: ethers.formatEther(ethMin*BigInt(10000)/BigInt(9800))
        };
    
      } catch (error) {
        console.error("Error validating price and getting min amounts:", error);
        return {
          success: false,
          error: error.message || "Failed to validate price and get min amounts",
          details: error
        };
      }
    }

    // Fetch total rewards from protocol fees
    export async function getTotalRewards() { //Yearly rewards generates
      const lendingContract = getLendingContract(provider);
      const totalRewards = await lendingContract.totalRewards();
      return ethers.formatEther(totalRewards);
    }
    
    // Fetch total ETH LENT (AVAILABLE + LENDED). TO get LENDED simply substract AVAILABLE + LENDED by ContractBalance
    export async function getTotalSupply() { 
      const lendingContract = getLendingContract(provider);
      const totalSupply = await lendingContract.totalSupply();
      return ethers.formatEther(totalSupply);
    }
    
    // Fetch total LP rewards for a specific token
    async function getTotalRewardsLp(tokenAddress) { //Yearly rewards for a token
      const lendingContract = getLendingContract(provider);
      const totalRewardsLp = await lendingContract.totalRewardsLp(tokenAddress);
      return ethers.formatEther(totalRewardsLp);
    }
    
    // Fetch total LP supply for a specific token
    async function getTotalSupplies(tokenAddress) { //Amount of LP tokens lended for a token
      const lendingContract = getLendingContract(provider);
      const totalSupplies = await lendingContract.totalSupplies(tokenAddress);
      return ethers.formatEther(totalSupplies);
    }
    
    // Get ETH balance of lending contract
    // This gives balance available for lending/flashloan
    export async function getLendingContractBalance() {
      try {
        // Get balance in wei
        const balance = await provider.getBalance(LENDING_ADDRESS);
        
        // Convert to ETH and return
        return ethers.formatEther(balance);
      } catch (error) {
        console.error("Error fetching lending contract balance:", error);
        throw error;
      }
    }
    
    
    // ========= READ FUNCTIONS ===========
    
    //MyBorrows and MyLoans page, show info for each loan/borrow
    export async function getBorrowInfo(lender, borrower) {
     try{ 
        const lendingContract = getLendingContract(provider);
        const borrowInfo = await lendingContract.borrows(lender, borrower);
        let tokenDecimals = await getTokenDecimals(borrowInfo.tokenAddress);
        return {
          unlockTimestamp: borrowInfo.unlockTimestamp.toString(),
          tokenAddress: borrowInfo.tokenAddress,
          isActive: borrowInfo.isActive,
          amountETHBorrowed: ethers.formatEther(borrowInfo.amountETHBorrowed),
          amountTokenBorrowed: ethers.formatUnits(borrowInfo.amountTokenBorrowed, tokenDecimals),
          liquidity: ethers.formatEther(borrowInfo.liquidity),
          euler0: borrowInfo.euler0.toString()
        };
      }catch(e){
        return {
          isActive: false,
        };
      }
    }
    
    //Active Lenders page show Eth available for each lender, should refresh this in DB for active lenders
    export async function getLenderInfo(lender) {
      const lendingContract = getLendingContract(provider);
      const lenderInfo = await lendingContract.lenders(lender);
      return {
        ETHAvailable: ethers.formatEther(lenderInfo.ETHAvailable),
        totalLent: ethers.formatEther(lenderInfo.totalLent),
        euler0: lenderInfo.euler0.toString(),
        lock: lenderInfo.lock
      };
    }
    
    //in myLoans page should display all borrowers a lender has made a loan to then show info for each (when selected) with getBorrowInfo
    export async function getBorrowers(lender) {
      const lendingContract = getLendingContract(provider);
      return await lendingContract.getBorrowers(lender);
    }
    
    //In myBorrows page should desiplay all lenders a borrower has borrowed from  then show info for each (when selected) with getBorrowInfo
    export async function getLenders(borrower) {
      const lendingContract = getLendingContract(provider);
      return await lendingContract.getLenders(borrower);
    }
    
    //Active lenders page
    export async function getActiveLenders() {
      const lendingContract = getLendingContract(provider);
      return await lendingContract.getActiveLenders();
    }
    
    
    //In myBorrows and myLoans page for each also show the current rewards cumulated by that borrow
    export async function viewShareBorrow(lender, borrower) {
      const lendingContract = getLendingContract(provider);
      const share = await lendingContract.viewShareBorrow(lender, borrower);
      return ethers.formatEther(share);
    }
    
    //rewards page. These rewards come from LP fees
    export async function viewShareLp(signer) {
      const lendingContract = getLendingContract(signer);
      const share = await lendingContract.viewShareLp();
      return ethers.formatEther(share);
    }

    //rewards page, these rewards come from protocol fees which rewards lenders while their ETH is staked in the lending pool
    export async function viewShareLending(signer) {
      const lendingContract = getLendingContract(signer);
      const share = await lendingContract.viewShareLending();
      return ethers.formatEther(share);
    }
    
    // ========= WRITE FUNCTIONS ===========
    
    //lender can deposit eth, minimum deposit is $100 or call will fail.
    export async function depositETH(amount, randomPair, signer) {
      const lendingContract = getLendingContract(signer);
      const amountWei = ethers.parseEther(amount);
      await lendingContract.depositETH(
        randomPair,
        { value: BigInt(amountWei.toString()) }
      );
    }
    
    //lender can withdraw available ETH anytime. 
    export async function withdrawETH(randomPair, signer) {
      const lendingContract = getLendingContract(signer);
      await lendingContract.withdrawAvailableETH(randomPair);
    }
    
    //In MyLoans/MyBorrows page. Similar to unstake in hardlock, check if enough time has passed
    export async function closeBorrow(lender, borrower, signer) {
      const lendingContract = getLendingContract(signer);
      await lendingContract.closeBorrow(lender, borrower);
    }
     
    //Claim total rewards generated by LP fees (lenders and borrowers)
    export async function claimShareLp(randomPair, signer) {
      const lendingContract = getLendingContract(signer);
      await lendingContract.claimShareLp(randomPair);
    }
    
    //Claim total rewards generated by protocol fees (lenders)
    export async function claimShareLending(randomPair, signer) {
      const lendingContract = getLendingContract(signer);
      await lendingContract.claimShareLending(randomPair);
    }
    
    
    export async function borrowETH(lender, amountToken, tokenAddress, signer) {
        const lendingContract = getLendingContract(signer);
        const tokenContract = new ethers.Contract(tokenAddress, ERC20, signer);
    
        const decimals = await tokenContract.decimals();
        const amountTokenWei = ethers.parseUnits(amountToken.toString(), decimals);
    
        // Check current allowance
        const currentAllowance = await tokenContract.allowance(
          signer.getAddress(),
          LENDING_ADDRESS
        );
    
        // If allowance is insufficient, request approval
        if (currentAllowance < amountTokenWei) {
          console.log("Requesting token approval...");
          const approvalTx = await tokenContract.approve(
            LENDING_ADDRESS,
            ethers.MaxUint256
          );
          let txn = await approvalTx.wait();
          console.log("Token approval confirmed", txn);
        }
    
        // Call borrowETH function
        const borrowTx = await lendingContract.borrowETH(
          lender,
          amountTokenWei,
          tokenAddress
        );
    
        // Wait for transaction confirmation
        const receipt = await borrowTx.wait();
        
        // Return transaction details
        return {
          success: true,
          transactionHash: receipt.transactionHash,
          blockNumber: receipt.blockNumber
        };
    
      /*} catch (error) {
        console.error("Error in borrowETH:", error);
        throw {
          success: false,
          error: error.message || "Transaction failed",
          details: error
        };
      }*/
    }
    
    
    //===== Oracle ===========
    async function calculateRequiredETHAmount(tokenAddress, amountTokens) {
      const oracleContract = new ethers.Contract(ORACLE_ADDRESS, oracleABI, provider);
      const decimals = await getTokenDecimals(tokenAddress);
      const amountTokensWei = ethers.parseUnits(amountTokens.toString(), decimals);
      
      const amountETH = await oracleContract.calculateRequiredETHAmount(
        tokenAddress,
        amountTokensWei
      );
      
      return ethers.formatEther(amountETH);
    }
    
    export async function findBestLender(tokenAddress, amountTokens, borrower) {

        // Get required ETH amount
        const requiredETH = await calculateRequiredETHAmount(tokenAddress, amountTokens);
        const requiredETHWei = ethers.parseEther(requiredETH);

        const activeLenders = await getActiveLenders();

        for (const lender of activeLenders) {
          const lenderAddress = lender[0];
          const ethAvailable = lender[1];
          if (lenderAddress.toLowerCase() === borrower.toLowerCase()) {
            continue;
          }

          const borrowInfo = await getBorrowInfo(lenderAddress, borrower);
          if (borrowInfo.isActive) {
            continue;
          }
          if (ethAvailable >= requiredETHWei) {
            return {
              success: true,
              lender: lenderAddress,
              ethAvailable: ethers.formatEther(ethAvailable),
              requiredETH
            };
          }
        }

        throw new Error(`No eligible lender found with sufficient ETH. Required: ${requiredETH} ETH`);
        
      
      
    }

//index 0, to get Lp rewards hourly rate, index 1 to get protocol rewards hourly rate
  export async function hourlyRewards(index){
    const genesisTimestamp = 1736628635;
    const block = await provider.getBlock();
    const currentTimestamp = block.timestamp;
    const elapsedSeconds = currentTimestamp - genesisTimestamp;
    let elapsedHours = Math.round(elapsedSeconds / 86400);
    if (elapsedHours == 0) {
      elapsedHours =1
    }
    let router = new ethers.Contract("0xCEDd366065A146a039B92Db35756ecD7688FCC77", ROUTER.abi, provider);
    let unitUsd = await router.usdcToEth(1);
    if (index == 0) {
      let usdtRewards = await getTotalRewardsLp("0xdac17f958d2ee523a2206206994597c13d831ec7");
      let usdcRewards = await getTotalRewardsLp("0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48");
      let totalRewards = Number(ethers.parseEther(usdtRewards)) + Number(ethers.parseEther(usdcRewards));
      let usdValue = totalRewards/Number(unitUsd)
      return Math.round(usdValue/elapsedHours)
    } else {

    } if (index == 1) {
      let lendRewards = Number(ethers.parseEther(await getTotalRewards()));
      let usdValue = lendRewards/Number(unitUsd);
      return Math.round(usdValue/elapsedHours);
    } 
  };

export async function convertEthToUSD2(ethAmount) { //else use ethers.parseEther(amount.toString()); to go from 0.01 to 1000000000
  let ethAmountWei = ethers.parseEther(ethAmount.toString())
  //console.log(ethAmountWei)
  let router = new ethers.Contract("0xCEDd366065A146a039B92Db35756ecD7688FCC77", ROUTER.abi, provider);
  let unitUsd = await router.usdcToEth(1);
  return Math.round((Number(ethAmountWei)/Number(unitUsd))*100)/100
}